export class JobTemplate {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "jobTimeout",
            "baseName": "jobTimeout",
            "type": "number",
            "format": ""
        },
        {
            "name": "retryPolicy",
            "baseName": "retryPolicy",
            "type": "JobTemplateRetryPolicy",
            "format": ""
        },
        {
            "name": "sparkSubmitParams",
            "baseName": "sparkSubmitParams",
            "type": "SparkJobSparkSubmitParams",
            "format": ""
        },
        {
            "name": "storageConfig",
            "baseName": "storageConfig",
            "type": "SparkJobStorageConfig",
            "format": ""
        },
        {
            "name": "eonSparkVersions",
            "baseName": "eonSparkVersions",
            "type": "Array<EonSparkVersion>",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return JobTemplate.attributeTypeMap;
    }
    constructor() {
    }
}
